exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".report-list ul[data-v-68cb61cc]{list-style-type:circle;padding-inline-start:1.3em}.report-list ul .error[data-v-68cb61cc]{font-weight:normal}.report-list ul small[data-v-68cb61cc]{background:#ddd;border-radius:2px;padding:1px 2px;border:1px solid #ccc;text-decoration:none;display:inline-block}", ""]);

